import styled, { css } from 'styled-components'
import { transparentize } from 'polished'

export const AttributeContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  margin-right: auto;
`

export const ComponentName = styled.div`
  flex: 1;
  min-width: 0;
  padding-right: 12px;
`

export const ElementIconContainer = styled.div<{ $isComponent?: boolean }>(
  ({ theme, $isComponent }) => css`
    position: relative;

    display: flex;
    justify-content: center;
    align-items: center;
    flex: none;

    width: 36px;
    height: 36px;

    background-color: ${theme.colors.background.tertiary.C};
    border-radius: 4px;

    color: ${$isComponent
      ? theme.colors.inspect.symbol.A
      : theme.colors.foreground.secondary.D};

    margin-right: 12px;

    ${$isComponent &&
    css`
      background-color: ${transparentize(0.9, theme.colors.inspect.symbol.A)};
    `}
  `
)
